import { Mic, PenLine, Sparkles, Pencil, Trash2, ArrowRight } from 'lucide-react';
import type { CapturedIdea } from '../../lib/capturedIdeas';

const SOURCE_META: Record<string, { icon: any; label: string }> = {
  whatsapp: { icon: Mic, label: 'via WhatsApp' },
  handmatig: { icon: PenLine, label: 'handmatig' },
  ai_suggestie: { icon: Sparkles, label: 'AI-suggestie' },
};

interface Props {
  idea: CapturedIdea;
  onEdit: (idea: CapturedIdea) => void;
  onDelete: (idea: CapturedIdea) => void;
  onWorkOut: (idea: CapturedIdea) => void;
}

export function IdeaCard({ idea, onEdit, onDelete, onWorkOut }: Props) {
  const meta = SOURCE_META[idea.source] ?? SOURCE_META.handmatig;
  const SourceIcon = meta.icon;
  const inProgress = idea.status === 'in_bewerking';

  return (
    <div className="bg-white rounded-2xl border border-gray-200 p-5">
      <div className="flex items-start justify-between gap-3 mb-2">
        <h3 className="text-lg font-bold text-[#231F20]">{idea.title}</h3>
        <span className="inline-flex items-center gap-1 text-xs text-gray-500 whitespace-nowrap">
          <SourceIcon className="w-3.5 h-3.5" /> {meta.label}
        </span>
      </div>
      <p className="text-gray-600 mb-3 line-clamp-2">{idea.content}</p>
      <div className="flex items-center justify-between">
        <span className="text-sm text-gray-400">
          {new Date(idea.created_at).toLocaleDateString('nl-NL', { day: 'numeric', month: 'long' })}
          {inProgress && <span className="ml-2 text-[#FF6B35] font-medium">⏳ bezig</span>}
        </span>
        <div className="flex items-center gap-2">
          <button onClick={() => onDelete(idea)} className="p-2 text-gray-400 hover:text-red-600" aria-label="Verwijder">
            <Trash2 className="w-4 h-4" />
          </button>
          <button onClick={() => onEdit(idea)} className="btn-secondary inline-flex items-center gap-1">
            <Pencil className="w-4 h-4" /> Bewerk
          </button>
          <button onClick={() => onWorkOut(idea)} className="btn-primary inline-flex items-center gap-1">
            {inProgress ? 'Ga verder' : 'Werk uit'} <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
